import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import HeadingIcon from '@assets/icons/tools.svg?react';

export const Services = () => {
    const { t } = useTranslation();

    // Track the open accordion item
    const [openIndex, setOpenIndex] = useState(null);

    // Handle accordion state, so that only one item can be open
    const handleToggle = (index) => {
        // Check if the clicked item is open
        const isItemOpen = (openIndex === index);
        // It's open: set state to null (close it)
        // It's not open: set state to the new index (open it).
        setOpenIndex(isItemOpen ? null : index);
    };

    // Data for the accordion
    const servicesData = [
        {
            title: t('services.S1_title'),
            subtitle: t('services.S1_subtitle'),
            content: t('services.S1_content'),
        },
        {
            title: t('services.S2_title'),
            subtitle: t('services.S2_subtitle'),
            content: t('services.S2_content'),
        },
        {
            title: t('services.S3_title'),
            subtitle: t('services.S3_subtitle'),
            content: t('services.S3_content'),
        },
        {
            title: t('services.S4_title'),
            subtitle: t('services.S4_subtitle'),
            content: t('services.S4_content'),
        },
        {
            title: t('services.S5_title'),
            subtitle: t('services.S5_subtitle'),
            content: t('services.S5_content'),
        }
    ];

    return (
        <section
            id="services"
            className="w-full py-8 md:py-12 bg-sectbg2"
        >
            <div className="max-w-[1280px] mx-auto px-8">
                {/* Grid: 1 column on mobile/tablet, 3 columns on desktop */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Column 1: Heading */}
                    <div className="lg:col-span-1">
                        <h2 className="text-4xl font-bold text-secttxthead tracking-tight flex items-center gap-x-4">
                            <HeadingIcon className="h-9 w-auto" />
                            <span>{t('nav.services')}</span>
                        </h2>
                    </div>

                    {/* Column 2: Content (spans 2 of 3 columns on desktop) - Accordion */}
                    <div className="lg:col-span-2">
                        <p className="text-lg text-secttxtprim">
                            {t('services.intro')}
                        </p>
                        <p className="text-lg text-secttxtprim mt-4">
                            {t('services.intro2')}
                        </p>
                        <div className="space-y-4 mt-6">
                            {servicesData.map((service, index) => (
                                <div key={index} className="collapse collapse-arrow bg-sectbgdd shadow-md">
                                    <input
                                        type="checkbox"
                                        // handleToggle sets the state of openIndex
                                        onChange={() => handleToggle(index)}
                                        // whenever openIndex changes, the whole component is rerendered and checked may change accordingly
                                        checked={openIndex === index}
                                    />
                                    <div className="collapse-title text-xl font-semibold text-secttxtdd">{service.title}</div>
                                    <div className="collapse-content text-lg font-normal text-secttxtsec">{service.content}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};